// 公共的接口需要存储到本地缓存
import tools from '@/utils/tools'
import Axios from 'axios'
import router from '../router'
import { message } from '@/plugins/element.js'
// import store from '@/store'
// 请求接口
function cache (key, url) {
  // key  存入缓存的名称
  // url  请求的路径
  if (sessionStorage.getItem(key)) {
    return JSON.parse(sessionStorage.getItem(key))
  } else {
    // 第一步： 获得XMLHttpRequest对象
    const xhr = new XMLHttpRequest()
    // 第三步： open一个链接
    xhr.open('get', url, false)
    xhr.setRequestHeader('Authorization', tools.authorization())
    // 第二步： 设置状态监听函数
    xhr.onreadystatechange = function () {
      // 第五步：在监听函数中，判断readyState=4 && status=200表示请求成功
      if (xhr.readyState === 4 && xhr.status === 200) {
        // 第六步： 使用responseText、responseXML接受响应数据，并使用原生JS操作DOM进行显示
        const reqData = JSON.parse(xhr.responseText)
        if (reqData.status === 403) {
          message.warning(`${reqData.message}`)
          setTimeout(function () {
            router.push('/404')
          }, 1500)
          setTimeout(function () {
            location.reload()
          }, 1600)
        }
        sessionStorage.setItem(key, JSON.stringify(reqData.data))
      }
      if (JSON.parse(xhr.response).status === 401) {
        message.warning(JSON.parse(xhr.response).message) // way1
        setTimeout(function () {
          // 登录失效跳转 登录页面
          window.location.href = '/web/userCenter'
        }, 1500)
      } else if (JSON.parse(xhr.response.status === 404)) {
        router.push('/404')
      }
    }
    // 第四步： send一个请求。 可以发送对象和字符串，不需要传递数据发送null
    xhr.send(null)
    if (JSON.parse(sessionStorage.getItem(key))) {
      const result = JSON.parse(sessionStorage.getItem(key))
      return result
    }
  }
}
// 过滤值
function getByKey (listFun, cacheKey, keyName, valueName, key) {
  const str = sessionStorage.getItem(cacheKey)
  if (str) {
    const findObj = JSON.parse(str)[key]
    if (findObj) {
      return findObj[valueName]
    }
    return undefined
  }

  const list = listFun()
  const obj = {}
  list.forEach(function (item) {
    obj[item[keyName]] = item
  })
  sessionStorage.setItem(cacheKey, JSON.stringify(obj))
  return getByKey(listFun, cacheKey, keyName, valueName, key)
}
// 所属地区
export const Region = {
  list () {
    const result = cache('dict.Region.list', `${process.env.VUE_APP_SERVER_URL}/dict/district/queryPullList`)
    return result
  },
  value (id, key) {
    const cacheKey = 'dict.Region.obj'
    return getByKey(Region.list, cacheKey, 'id', key, id)
  }
}
// 动态获取路由
export const UserCenterdRouter = {
  list () {
    const result = cache('dict.UserCenter_Router.list', `${process.env.VUE_APP_SERVER_URL}/ucenter/menu/listModelMenuTree?modelId=${process.env.VUE_APP_MODEL_ID}`)
    return result
  }
}
// 获取子系统
export const Subsystem = {
  list () {
    sessionStorage.removeItem('dict.sysmodel.list')
    const result = cache('dict.sysmodel.list', `${process.env.VUE_APP_SERVER_URL}/ucenter/sys-model/list`)
    return result
  },
  value (id, key) {
    sessionStorage.removeItem('dict.sysmodel.obj')
    const cacheKey = 'dict.sysmodel.obj'
    return getByKey(Subsystem.list, cacheKey, 'id', key, id)
  }
}
// 导入地址
export const uploadUrl = () => {
  return `${process.env.VUE_APP_SERVER_URL}/path/api-url/importYAPIJson`
}
export const department = {
  list () {
    const result = cache('dict.department.list', `${process.env.VUE_APP_SERVER_URL}/dict/department/queryPullList`)
    return result
  },
  value (id, key) {
    const cacheKey = 'dict.department.obj'
    return getByKey(department.list, cacheKey, 'id', key, id)
  }
}
// 获取系统id
export const modelID = () => {
  return process.env.MODEL_ID
}
// 获取接口管理下的导入上传地址
export const uploadUrlsJSON = (params) => {
  return Axios({
    url: `${process.env.VUE_APP_SERVER_URL}/path/api-url/importYAPIJson`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: tools.authorization()
    },
    transformRequest: [], // 图片上传formdata默认不用传参
    method: 'post',
    data: params
  })
}
// 获取上传地址
export const uploadUrls = (params) => {
  return Axios({
    url: `${process.env.FILE_SERVER_URL}/upload`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: tools.authorization()
    },
    transformRequest: [], // 图片上传formdata默认不用传参
    method: 'post',
    data: params
  })
}
